import { css, cx } from "@emotion/css";
import { XmarkIcon } from "@octopusdeploy/design-system-icons";
import { borderRadius, space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import React from "react";
import { Button } from "../Button/Button";
import { Tooltip } from "../Tooltip/Tooltip";
export type ProgressTrackerItemState = "Current" | "Pending" | "Done";
export interface ProgressTrackerProps {
    onClose?: () => void;
    showCloseButton?: boolean;
    closeButtonTooltip?: string;
    className?: string;
    children: React.ReactNode;
}
export const ProgressTracker = ({ onClose, showCloseButton = false, closeButtonTooltip, className, children }: ProgressTrackerProps): JSX.Element => {
    return (<div className={cx(styles.wrapper, className)}>
            <div className={styles.container}>
                {children}
                {showCloseButton && onClose && <CloseButton onClick={onClose} tooltip={closeButtonTooltip}/>}
            </div>
        </div>);
};
const CloseButton = ({ onClick, tooltip }: {
    onClick: () => void;
    tooltip?: string;
}) => {
    if (tooltip) {
        return (<div className={styles.closeButtonStyles}>
                <Tooltip content={<div className={styles.tooltipContentStyles}>{tooltip}</div>} position="top">
                    <Button importance="ghost" icon={<XmarkIcon size={20}/>} onClick={onClick}/>
                </Tooltip>
            </div>);
    }
    return (<div className={styles.closeButtonStyles}>
            <Button importance="ghost" icon={<XmarkIcon size={20}/>} onClick={onClick}/>
        </div>);
};
const styles = {
    wrapper: css({
        overflowX: "auto",
        background: themeTokens.color.background.secondary.default,
        borderRadius: borderRadius.small,
        "& *": {
            boxSizing: "border-box",
        },
    }),
    container: css({
        font: text.body.regular.xSmall,
        display: "flex",
        gap: space[8],
        alignItems: "center",
        justifyContent: "start",
        padding: `${space[8]} ${space[12]}`,
        userSelect: "none",
        height: "2.75rem", // required to prevent close button increasing height
    }),
    tooltipContentStyles: css({
        position: "relative",
        bottom: "4px",
        width: "174px",
        height: "32px",
        marginTop: space[2],
        marginBottom: space[2],
    }),
    closeButtonStyles: css({
        marginLeft: "auto",
    }),
};
